import React, { useEffect } from 'react';
import { SummaryList, Button } from 'govuk-react-jsx';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
  getCurrentLanguage,
  getCopyProviderCY,
  getCopyProviderEN,
} from '../../features/app/appSlice';
import {
  getAccountLandLordType,
  getAnswers,
  setAnswers,
} from '../../features/registration/registrationJourneySlice';
import {
  formatMobileNumber,
  formatTelephoneNumber,
} from '../../utils/format-number';
import { checkAnswers } from '../../firebase';
import useTitle from '../../hooks/useTitle';

const CheckAnswers = () => {
  const answers = useSelector(getAnswers);
  const landlordTypeSelectedRedux = useSelector(getAccountLandLordType);
  const currentLanguage = useSelector(getCurrentLanguage);
  const copyProviderCY = useSelector(getCopyProviderCY);
  const copyProviderEN = useSelector(getCopyProviderEN);
  const copyProvider =
    currentLanguage === 'en' ? copyProviderEN : copyProviderCY;
  const history = useHistory();

  const isPRP =
    landlordTypeSelectedRedux ===
    'Property factor or a social housing provider';

  const dispatch = useDispatch();
  useTitle(
    'landlordReg.CheckAnswers.s21',
    'Check your answers - OZEV Electric Vehicle Chargepoint Grant - GOV.UK'
  );

  useEffect(() => {
    checkAnswers()
      .then((response) => {
        const { data } = response;

        dispatch(setAnswers(data));
      })
      .catch(() => {
        // TODO: Show error message
      });
  }, []);

  const handleBtnClick = () => {
    history.push('/landlordReg/declaration');
  };
  const name = isPRP
    ? [
        {
          key: {
            children: copyProvider.getCopy(
              'landlordReg.CheckAnswers.s5',
              'Name'
            ),
          },
          value: {
            children: (
              <p className="govuk-body ">
                {answers.firstName} {answers.lastName}
              </p>
            ),
          },
        },
      ]
    : [
        {
          key: {
            children: copyProvider.getCopy(
              'landlordReg.CheckAnswers.s19',
              'First name'
            ),
          },
          value: {
            children: <p className="govuk-body ">{answers.firstName}</p>,
          },
        },
        {
          key: {
            children: copyProvider.getCopy(
              'landlordReg.CheckAnswers.s20',
              'Last name'
            ),
          },
          value: {
            children: <p className="govuk-body ">{answers.lastName}</p>,
          },
        },
      ];

  const pageModel = (
    <>
      <h1 className="govuk-heading-xl">
        {copyProvider.getCopy(
          'landlordReg.CheckAnswers.s1',
          'Check your answers'
        )}
      </h1>
      <h2 className="govuk-heading-m">
        {copyProvider.getCopy('landlordReg.CheckAnswers.s2', 'Account details')}
      </h2>
      {answers && (
        <SummaryList
          className="govuk-summary-list govuk-!-margin-bottom-9"
          rows={[
            {
              key: {
                children: copyProvider.getCopy(
                  'landlordReg.CheckAnswers.s3',
                  'Registered email'
                ),
              },
              value: {
                children: <p className="govuk-body">{answers.accountEmail}</p>,
              },
            },
            {
              key: {
                children: copyProvider.getCopy(
                  'landlordReg.CheckAnswers.s4',
                  'Type of account'
                ),
              },
              value: {
                children: <p className="govuk-body ">{answers.accountType}</p>,
              },
            },
            ...name,
            {
              key: {
                children: copyProvider.getCopy(
                  'landlordReg.CheckAnswers.s6',
                  'Role within the business'
                ),
              },
              value: {
                children: (
                  <p className="govuk-body">{answers.roleWithinBusiness}</p>
                ),
              },
            },
            {
              key: {
                children: copyProvider.getCopy(
                  'landlordReg.CheckAnswers.s7',
                  'Mobile number'
                ),
              },
              value: {
                children: (
                  <p className="govuk-body ">
                    {formatMobileNumber(answers.mobileNumber)}
                  </p>
                ),
              },
            },

            answers.phoneNumber && {
              key: isPRP
                ? {
                    children: copyProvider.getCopy(
                      'landlordReg.CheckAnswers.s23',
                      'Office landline number'
                    ),
                  }
                : {
                    children: copyProvider.getCopy(
                      'landlordReg.CheckAnswers.s8',
                      'Other telephone number'
                    ),
                  },
              value: {
                children: (
                  <p className="govuk-body ">
                    {formatTelephoneNumber(answers.phoneNumber)}
                  </p>
                ),
              },
            },
          ]}
        />
      )}

      <h2 className="govuk-heading-m">
        {copyProvider.getCopy(
          'landlordReg.CheckAnswers.s9',
          'Business details'
        )}
      </h2>
      {answers && (
        <SummaryList
          className="govuk-summary-list govuk-!-margin-bottom-9"
          rows={[
            (answers.accountType === 'Landlord' ||
              answers.accountType ===
                'Both Property Management Company And Landlord') && {
              key: {
                children: copyProvider.getCopy(
                  'landlordReg.CheckAnswers.s10',
                  'Type of landlord'
                ),
              },
              value: {
                children: isPRP ? (
                  <p className="govuk-body">
                    {copyProvider.getCopy(
                      'landlordReg.CheckAnswers.s27',
                      'Provider of Social Housing'
                    )}
                  </p>
                ) : (
                  <p className="govuk-body ">{answers.landlordType}</p>
                ),
              },
            },

            (answers.accountType === 'Landlord' ||
              answers.accountType ===
                'Both Property Management Company And Landlord') &&
              answers.landlordType === 'Private Landlord' && {
                key: {
                  children: copyProvider.getCopy(
                    'landlordReg.CheckAnswers.s13',
                    'Linked enterprise'
                  ),
                },
                value: {
                  children: (
                    <p className="govuk-body ">
                      {answers.isLinkedEnterprise ? 'Yes' : 'No'}
                    </p>
                  ),
                },
              },

            answers.companyRegNumber && {
              key: {
                children: copyProvider.getCopy(
                  'landlordReg.CheckAnswers.s14',
                  'Companies House number'
                ),
              },
              value: {
                children: (
                  <p className="govuk-body">{answers.companyRegNumber}</p>
                ),
              },
            },

            answers.socialHousingRegistrationNumber && {
              key: {
                children: copyProvider.getCopy(
                  'landlordReg.CheckAnswers.s24',
                  'Registration number'
                ),
              },
              value: {
                children: (
                  <p className="govuk-body">
                    {answers.socialHousingRegistrationNumber}
                  </p>
                ),
              },
            },

            answers.vatRegNumber && {
              key: {
                children: copyProvider.getCopy(
                  'landlordReg.CheckAnswers.s17',
                  'VAT registration number'
                ),
              },
              value: {
                children: (
                  <p className="govuk-body">
                    {answers.vatRegNumber && answers.vatRegNumber}
                  </p>
                ),
              },
            },

            answers.businessName && {
              key: isPRP
                ? {
                    children: copyProvider.getCopy(
                      'landlordReg.CheckAnswers.s25',
                      'Company name'
                    ),
                  }
                : {
                    children: copyProvider.getCopy(
                      'landlordReg.CheckAnswers.s15',
                      'Business name'
                    ),
                  },
              value: {
                children: <p>{answers.businessName}</p>,
              },
            },

            answers.businessAddressLine1 && {
              key: isPRP
                ? {
                    children: copyProvider.getCopy(
                      'landlordReg.CheckAnswers.s26',
                      'Company registered address'
                    ),
                  }
                : {
                    children: copyProvider.getCopy(
                      'landlordReg.CheckAnswers.s16',
                      'Business address'
                    ),
                  },
              value: {
                children: (
                  <div key="0" className="govuk-body">
                    <p className="govuk-body">
                      <section>
                        {answers.businessAddressLine1 &&
                          `${answers.businessAddressLine1},`}
                      </section>
                      <section>
                        {answers.businessAddressLine2 &&
                          `${answers.businessAddressLine2},`}
                      </section>
                      <section>
                        {answers.businessAddressCity &&
                          `${answers.businessAddressCity},`}
                      </section>
                      <section>
                        {answers.businessAddressCounty &&
                          `${answers.businessAddressCounty},`}
                      </section>
                      <section>
                        {answers.businessAddressPostcode &&
                          answers.businessAddressPostcode}
                        {answers.businessAddressCountry && ','}
                      </section>
                      <section>
                        {answers.businessAddressCountry &&
                          answers.businessAddressCountry}
                      </section>
                    </p>
                  </div>
                ),
              },
            },
          ]}
        />
      )}

      <Button
        className="govuk-button govuk-!-margin-top-7"
        onClick={handleBtnClick}
      >
        {copyProvider.getCopy(
          'landlordReg.CheckAnswers.s18',
          'Confirm and continue'
        )}
      </Button>
    </>
  );
  return pageModel;
};

export default CheckAnswers;
